import React from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const ParEmpList = ({
  apiRef,
  columns,
  employees,
  error,
  loading,
  rowModesModel,
  onRowModesModelChange,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
  processRowUpdate,
}) => {
  return (
    <div style={{ display: 'flex', height: '350px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          apiRef={apiRef}
          rows={employees ?? []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '거래처_담당자_리스트' },
          }}
          loading={loading}
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={onRowModesModelChange}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
          processRowUpdate={processRowUpdate}
          experimentalFeatures={{ newEditingApi: true }}
          initialState={{
            pinnedColumns: { right: ['actions'] },
            columns: {
              columnVisibilityModel: { id: false, employeeUuid: false },
            },
          }}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
        />
      </div>
    </div>
  );
};

export default ParEmpList;
